export interface PlaceInfo {
    location: string;
    placeId: string;
    description: string;
    relevance: number;
}
